import { getSessionForAccessInfo, checkGraphResponse } from "./GraphMain";
import { accessInfoType } from "../utils/classInfos";
import { getElementAppInfo } from "./graphAppInfoElementFunctions";
import { getHelperTables, getWorksheetUrlSection } from "./helper";
import { optimizeNameList } from "./names";

export async function getSheetUsedRange(
  accessInfo: accessInfoType,
  worksheetId: string
) {
  const sessionInfo  = await getSessionForAccessInfo(accessInfo);
  // check the info
  if (!sessionInfo || !sessionInfo.sessionId) return null;
  const {client, sessionId, fileUrl} = sessionInfo;

  const sheetRangeUrl =
    fileUrl + "/workbook/" + getWorksheetUrlSection(worksheetId) + "/usedRange?$select=values,formulas,numberFormat,cellCount,address";

  const $batch = {
    requests: [
      {
        url: sheetRangeUrl,
        method: "GET",
        id: "RANGE",
        headers: {
          "workbook-session-id": sessionId
        }
      },
      {
        url: fileUrl + "/workbook/names?$select=name,scope,type,value,comment",
        method: "GET",
        id: "NAMES",
        headers: {
          "workbook-session-id": sessionId
        }
      },
      {
        url: fileUrl + "/workbook/tables?$select=name",
        method: "GET",
        id: "TABLES",
        headers: {
          "workbook-session-id": sessionId
        }
      },
    ],
  };
  // RUN BATCH
  let res = await client
    .api("/$batch")
    .post($batch);

  checkGraphResponse(res, "getSheetUsedRange");  
  // RESULTS
  let range = res.responses[res.responses.findIndex((x) => x.id === "RANGE")]?.body;
  let tableTables = res.responses[res.responses.findIndex((x) => x.id === "TABLES")]?.body;
  if (range) {
    range.worksheetId = worksheetId;
  }
  //===========================
  // get the NAMES list
  //===========================
  let tempNames = res.responses[res.responses.findIndex((x) => x.id === "NAMES")];
  let names = optimizeNameList(tempNames.body.value);

  // helper tables
  const helperTables = getHelperTables(tableTables?.value);
  const hasHelperTables = helperTables.length > 0;
  // get the app info
  let appInfo = await getElementAppInfo(accessInfo, worksheetId, "sheet", sessionId, fileUrl, client, helperTables);

  return { worksheetId, range, names, appInfo, accessInfo, hasHelperTables, helperTables };
}

